export function mapNullableNonNegInt(raw, key) {
  const value = raw?.[key]
  if (value == null || value === '') {
    return null
  }
  const number = Number(value)
  if (!Number.isFinite(number) || number < 0) {
    return null
  }
  return Math.floor(number)
}

export function mapOptionalTrimmedString(value) {
  const text = String(value ?? '').trim()
  return text || null
}
